(function () {
  'use strict';

  function initSampleStudio(root) {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    var variantId = Number(root.dataset.sampleVariantId || 0);
    var variantAvailable = root.dataset.sampleVariantAvailable === 'true';
    var maxSamples = Number(root.dataset.sampleMax || 3);
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-sample-card]'));
    var familyButtons = Array.prototype.slice.call(root.querySelectorAll('.sample-studio__family[data-sample-family]'));
    var selection = root.querySelector('.sample-studio__selection');
    var counter = root.querySelector('[data-sample-counter]');
    var selectionLink = root.querySelector('[data-sample-selection-link]');
    var originLink = root.querySelector('[data-sample-origin-link]');
    var originLabel = root.querySelector('[data-sample-origin-label]');
    var catalogTitle = root.querySelector('[data-sample-catalog-title]');
    var catalogCount = root.querySelector('[data-sample-catalog-count]');
    var status = root.querySelector('[data-sample-status]');
    var activeFamily = 'wood';
    var originMode = new URLSearchParams(window.location.search).get('origen');
    var cart = null;
    var pending = false;
    var headerSection = document.querySelector('.header-section');

    function syncToolbarOffset() {
      if (!headerSection) return;
      var headerVisible = !headerSection.classList.contains('header-hidden');
      root.style.setProperty('--sample-toolbar-top', headerVisible ? 'var(--header-height, 0px)' : '0px');
    }

    if (headerSection && window.MutationObserver) {
      new MutationObserver(syncToolbarOffset).observe(headerSection, { attributes: true, attributeFilter: ['class'] });
      syncToolbarOffset();
    }

    var studioActiveClass = 'sample-studio-active';
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (entries) {
        var studioVisible = entries.some(function (entry) { return entry.isIntersecting; });
        document.documentElement.classList.toggle(studioActiveClass, studioVisible);
      }, { threshold: 0 }).observe(root);
    }

    function route(path) {
      var rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
      return rootPath + path.replace(/^\//, '');
    }

    function setStatus(message, isError) {
      if (!status) return;
      status.textContent = message || '';
      status.classList.toggle('is-error', Boolean(isError));
    }

    function sampleLines() {
      if (!cart || !Array.isArray(cart.items)) return [];
      return cart.items.filter(function (item) {
        return Number(item.variant_id) === variantId;
      });
    }

    function sampleCount() {
      return sampleLines().reduce(function (sum, item) {
        return sum + Number(item.quantity || 0);
      }, 0);
    }

    function lineMatchesCard(item, card) {
      var properties = item.properties || {};
      var key = card.dataset.sampleKey || '';
      var handle = card.dataset.sampleHandle || '';
      var code = card.dataset.sampleCode || '';
      var title = card.dataset.sampleTitle || '';
      return properties._sample_key === key ||
        properties._sample_source_handle === handle ||
        properties._Producto === handle ||
        properties.Código === code ||
        properties.Muestra === title;
    }

    function isCardAdded(card) {
      return sampleLines().some(function (item) { return lineMatchesCard(item, card); });
    }

    function syncCards() {
      var count = sampleCount();
      cards.forEach(function (card) {
        var button = card.querySelector('[data-sample-add]');
        var label = card.querySelector('[data-sample-add-label]');
        var icon = card.querySelector('[data-sample-add-icon]');
        if (!button || !label) return;
        var added = isCardAdded(card);
        card.classList.toggle('is-added', added);
        button.disabled = pending || !variantAvailable || !variantId || (!added && count >= maxSamples);
        button.setAttribute('aria-pressed', String(added));
        if (added) {
          label.textContent = 'Quitar';
          if (icon) icon.textContent = '×';
        }
        else if (!variantAvailable || !variantId) label.textContent = 'No disponible';
        else if (count >= maxSamples) label.textContent = 'Máximo alcanzado';
        else {
          label.textContent = 'Agregar';
          if (icon) icon.textContent = '+';
        }
      });

      if (counter) {
        counter.textContent = count + ' de ' + maxSamples + (count === 1 ? ' seleccionada' : ' seleccionadas');
        counter.dataset.compact = count + '/' + maxSamples;
      }
      if (selection) selection.dataset.hasSelection = String(count > 0);
      if (selectionLink) selectionLink.hidden = count === 0;
    }

    function syncFamily() {
      var visible = 0;
      cards.forEach(function (card) {
        var show = card.dataset.sampleFamily === activeFamily;
        card.hidden = !show;
        if (show) visible += 1;
      });
      familyButtons.forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.dataset.sampleFamily === activeFamily));
      });
      if (catalogTitle) {
        catalogTitle.textContent = activeFamily === 'wood'
          ? 'Madera natural'
          : activeFamily === 'vinyl'
            ? 'Pisos vinílicos'
            : 'Wall Panels';
      }
      if (catalogCount) catalogCount.textContent = visible + (visible === 1 ? ' diseño' : ' diseños');
      if (originLink) {
        var origin = originMode === 'proyecto'
          ? { label: 'Explorar por proyecto', ariaLabel: 'Volver a explorar por proyecto', url: '/collections#muestras' }
          : activeFamily === 'vinyl'
            ? { label: 'Pisos vinílicos', url: '/collections/pisos-vinilicos' }
            : activeFamily === 'wall'
              ? { label: 'Wall Panels', url: '/collections/wall-panel?view=wall-panels-editorial' }
              : { label: 'Pisos de madera', url: '/collections/pisos-de-madera' };
        originLink.href = origin.url;
        originLink.setAttribute('aria-label', origin.ariaLabel || 'Volver a ' + origin.label);
        if (originLabel) originLabel.textContent = origin.label;
      }
    }

    function rememberSampleOrigin(card) {
      if (!card) return;
      try {
        var family = card.dataset.sampleFamily === 'vinyl'
          ? 'vinyl'
          : card.dataset.sampleFamily === 'wall'
            ? 'wall'
            : 'wood';
        var familyParameter = family === 'wood' ? 'madera' : family === 'vinyl' ? 'vinilico' : 'wall-panels';
        var returnKey = family === 'wood'
          ? 'mrp:explorer-return:wood'
          : family === 'vinyl'
            ? 'mrp:explorer-return:vinyl'
            : 'mrp:wall-panels';
        var returnUrl = new URL(window.location.href);
        returnUrl.searchParams.set('view', 'muestras-editorial');
        returnUrl.searchParams.set('familia', familyParameter);
        returnUrl.hash = 'muestras-catalogo';
        window.sessionStorage.setItem(
          returnKey,
          JSON.stringify({
            url: returnUrl.pathname + returnUrl.search + returnUrl.hash,
            label: 'Volver a elegir muestras',
            productPath: new URL(card.dataset.sampleUrl || '/', window.location.origin).pathname
          })
        );
      } catch (error) {
        // Storage can be unavailable in strict privacy contexts; navigation still works.
      }
    }

    function fetchCart() {
      return fetch(route('cart.js'), { headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (!response.ok) throw new Error('cart');
          return response.json();
        })
        .then(function (nextCart) {
          cart = nextCart;
          syncCards();
          if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'sample-studio', cart: nextCart });
          }
          return nextCart;
        });
    }

    function updateSampleLines(card, quantity) {
      var matchingLines = sampleLines().filter(function (item) { return lineMatchesCard(item, card); });
      var updates = {};
      matchingLines.forEach(function (item) { updates[item.key] = quantity; });
      return fetch(route('cart/update.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function (response) {
        if (!response.ok) throw new Error('update');
        return response.json();
      });
    }

    function toggleSample(card, button) {
      if (pending || button.disabled || !variantId || !variantAvailable) return;
      pending = true;
      setStatus('');
      syncCards();
      var label = card.querySelector('[data-sample-add-label]');
      var requestedTitle = card.dataset.sampleTitle || 'La muestra';
      if (label) label.textContent = button.getAttribute('aria-pressed') === 'true' ? 'Quitando…' : 'Agregando…';

      fetchCart().then(function () {
        if (isCardAdded(card)) {
          return updateSampleLines(card, 0).then(function () { return 'removed'; });
        }
        if (sampleCount() >= maxSamples) {
          setStatus('Ya elegiste el máximo de ' + maxSamples + ' muestras. Podés modificar tu selección en el carrito.', true);
          return null;
        }

        return fetch(route('cart/add.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{
              id: variantId,
              quantity: 1,
              properties: {
                'Muestra': card.dataset.sampleTitle || '',
                'Código': card.dataset.sampleCode || '',
                'Crédito bonificable': root.dataset.sampleCreditLabel || '',
                'Vigencia del crédito': root.dataset.sampleCreditDays + ' días',
                '_sample_key': card.dataset.sampleKey || '',
                '_sample_source_handle': card.dataset.sampleHandle || '',
                '_sample_source_url': card.dataset.sampleUrl || '',
                '_sample_family': card.dataset.sampleFamily || '',
                '_Producto': card.dataset.sampleHandle || ''
              }
            }]
          })
        }).then(function (response) {
          if (!response) return null;
          if (!response.ok) throw new Error('add');
          return response.json().then(function () { return 'added'; });
        });
      }).then(function (result) {
        if (!result) return fetchCart();
        return fetchCart().then(function () {
          setStatus(result === 'removed'
            ? requestedTitle + ' se quitó de tu selección.'
            : requestedTitle + ' se agregó a tu selección.');
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } }));
        });
      }).catch(function () {
        setStatus('No pudimos agregar la muestra. Probá nuevamente o escribinos por WhatsApp.', true);
      }).finally(function () {
        pending = false;
        syncCards();
      });
    }

    familyButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        activeFamily = button.dataset.sampleFamily || 'wood';
        syncFamily();
        var url = new URL(window.location.href);
        url.searchParams.set('familia', activeFamily === 'wood' ? 'madera' : activeFamily === 'vinyl' ? 'vinilico' : 'wall-panels');
        window.history.replaceState({}, '', url.toString());
      });
    });

    cards.forEach(function (card) {
      var button = card.querySelector('[data-sample-add]');
      if (button) button.addEventListener('click', function () { toggleSample(card, button); });
      card.querySelectorAll('[data-sample-product-link]').forEach(function (link) {
        link.addEventListener('click', function () { rememberSampleOrigin(card); });
      });
    });

    var requestedFamily = new URL(window.location.href).searchParams.get('familia');
    if (requestedFamily === 'vinilico') activeFamily = 'vinyl';
    else if (requestedFamily === 'wall-panels') activeFamily = 'wall';
    syncFamily();
    syncCards();
    fetchCart().catch(function () {
      setStatus('No pudimos leer tu selección. Recargá la página para intentarlo nuevamente.', true);
      pending = false;
      syncCards();
    });

    document.addEventListener('cart:refresh', function () {
      window.setTimeout(function () { fetchCart().catch(function () {}); }, 100);
    });
    document.addEventListener('cart:updated', function () {
      window.setTimeout(function () { fetchCart().catch(function () {}); }, 80);
    });
    window.addEventListener('pageshow', function () { fetchCart().catch(function () {}); });
  }

  function boot() {
    document.querySelectorAll('[data-sample-studio]').forEach(initSampleStudio);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
